import { render, staticRenderFns } from "./ManageGroupAccessModal.vue?vue&type=template&id=46bf7c89&scoped=true"
import script from "./ManageGroupAccessModal.vue?vue&type=script&lang=js"
export * from "./ManageGroupAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf7c89",
  null
  
)

export default component.exports